// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__a34XW","fileBtn":"File_fileBtn__2qHI_","closeBtn":"File_closeBtn__2_25X","fileSelected":"File_fileSelected__3259U","disabled":"File_disabled__tPpWy"};